import { type FC, type PropsWithChildren, type ReactNode } from 'react'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import { type CommonProps } from '@/utils/types'
import clsx from 'clsx'
import NextImage from 'next/image'
import close from '../../../public/icon-close-dialog.svg'

import styles from './Modal.module.scss'

/**
 * Displays a modal dialog with a title, description, and action button.
 */
const Modal: FC<DialogPrimitive.DialogProps> = DialogPrimitive.Root

/**
 * Triggers the modal dialog.
 */
const Trigger: FC<DialogPrimitive.DialogTriggerProps> = DialogPrimitive.Trigger

const Content: FC<ModalContentProps> = (props) => {
  const { title, className, children, ...rest } = props
  const classList = clsx(
    styles.modalContent,
    // eslint-disable-next-line max-len
    'duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95',
    className)

  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className={styles.overlay}>
        <DialogPrimitive.Content className={classList} {...rest}>
          <header className={styles.header}>
            <DialogPrimitive.Close className={styles.closeButton} aria-label="Close">
              <NextImage
                src={close}
                alt=""
                width={20}
                height={20}
              />
            </DialogPrimitive.Close>
            <DialogPrimitive.Title>
              {title}
            </DialogPrimitive.Title>
          </header>
          <div>
            {children}
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Overlay>
    </DialogPrimitive.Portal>
  )
}

export interface ModalContentProps extends PropsWithChildren<CommonProps>, Omit<DialogPrimitive.DialogContentProps, 'title'> {
  title: ReactNode
}

export default Object.assign(Modal, {
  Trigger,
  Content
})
